import { IRequestItem, IRequestItemRow } from "../../../models/Request";

export const actionTypes = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  INIT_LOADER: "INIT_LOADER",
  FETCH_CSV_REQUEST: "FETCH_CSV_REQUEST",
  FETCH_CSV_REQUEST_SUCCESS: "FETCH_CSV_REQUEST_SUCCESS",
  FETCH_CSV_REQUEST_FAILURE: "FETCH_CSV_REQUEST_FAILURE",
  HISTORY_REQUEST: "HISTORY_REQUEST",
  HISTORY_SUCCESS: "HISTORY_SUCCESS",
  HISTORY_FAILURE: "HISTORY_FAILURE",
  RETRY_REQUEST: "RETRY_REQUEST",
  RETRY_REQUEST_SUCCESS: "RETRY_REQUEST_SUCCESS",
  RETRY_REQUEST_FAILURE: "RETRY_REQUEST_FAILURE",
  SELECT_REQUEST: "SELECT_REQUEST",
  HISTORY_DETAIL: "HISTORY_DETAIL",
  HISTORY_DETAIL_SUCCESS: "HISTORY_DETAIL_SUCCESS",
  HISTORY_DETAIL_FAILURE: "HISTORY_DETAIL_FAILURE",
  CLEAR_DETAIL: "CLEAR_DETAIL",
  DELETE_ATTACHMENT: "DELETE_ATTACHMENTS",
  DELETE_ATTACHMENT_SUCCESS: "DELETE_ATTACHMENTS_SUCCESS",
  DELETE_ATTACHMENT_FAILURE: "DELETE_ATTACHMENTS_FAILURE",
  SAVE_ATTACHMENTS: "SAVE_ATTACHMENTS",
  SAVE_ATTACHMENTS_SUCCESS: "SAVE_ATTACHMENTS_SUCCESS",
  SAVE_ATTACHMENTS_FAILURE: "SAVE_ATTACHMENTS_FAILURE",
};

export const initLoader = () => ({
  type: actionTypes.INIT_LOADER,
});

export const successAction = (res: Boolean) => ({
  type: actionTypes.SUCCESS,
  res,
});

export const errorAction = (err: any) => ({
  type: actionTypes.ERROR,
  err,
});

export const fetchCSVReqAction = (payload: any) => ({
  type: actionTypes.FETCH_CSV_REQUEST,
  payload,
});

export const fetchCSVReqActionSuccess = (payload: any) => ({
  type: actionTypes.FETCH_CSV_REQUEST_SUCCESS,
  payload,
});

export const fetchCSVReqActionFailure = (payload: any) => ({
  type: actionTypes.FETCH_CSV_REQUEST_FAILURE,
  payload,
});

export const historyRequest = (payload: any) => ({
  type: actionTypes.HISTORY_REQUEST,
  payload,
});

export const historySuccess = (payload: IRequestItemRow[]) => ({
  type: actionTypes.HISTORY_SUCCESS,
  payload,
});

export const historyFailure = (err: any) => ({
  type: actionTypes.HISTORY_FAILURE,
  err,
});

export const retryRequestAction = (payload: string[]) => ({
  type: actionTypes.RETRY_REQUEST,
  payload,
});

export const retryRequestActionSuccess = (payload: any) => ({
  type: actionTypes.RETRY_REQUEST_SUCCESS,
  payload,
});

export const retryRequestActionFailure = (err: any) => ({
  type: actionTypes.RETRY_REQUEST_FAILURE,
  err,
});

export const selectRequest = (payload: IRequestItem) => ({
  type: actionTypes.SELECT_REQUEST,
  payload,
});

export const historyDetail = (id: String) => ({
  type: actionTypes.HISTORY_DETAIL,
  id,
});

export const historyDetailSuccess = (payload: any) => ({
  type: actionTypes.HISTORY_DETAIL_SUCCESS,
  payload,
});

export const historyDetailFailure = (error: any) => ({
  type: actionTypes.HISTORY_DETAIL_FAILURE,
  error,
});

export const deleteAttachment = (id: string) => ({
  type: actionTypes.DELETE_ATTACHMENT,
  id,
});

export const deleteAttachmentSuccess = (payload: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_SUCCESS,
  payload,
});

export const deleteAttachmentFailure = (error: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_FAILURE,
  error,
});

export const saveAttachments = (id: string, files: any) => ({
  type: actionTypes.SAVE_ATTACHMENTS,
  id,
  files,
});

export const saveAttachmentsSuccess = (payload: any) => ({
  type: actionTypes.SAVE_ATTACHMENTS_SUCCESS,
  payload,
});

export const saveAttachmentsFailure = (error: any) => ({
  type: actionTypes.SAVE_ATTACHMENTS_FAILURE,
  error,
});

export const clearDetail = () => ({ type: actionTypes.CLEAR_DETAIL });
